import React from 'react';

const LinkBrokenIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_13516_444550)">
      <path
        d="M5.66671 10.333L10.3334 5.66633M6.00004 2.66634V1.33301M10 13.333V14.6663M2.66671 5.99967H1.33337M13.3334 9.99967H14.6667M3.27618 3.27582L2.33337 2.33301M12.7239 12.7235L13.6667 13.6663M8.00006 11.7709L6.58585 13.1851C5.54445 14.2265 3.85601 14.2265 2.81461 13.1851C1.77322 12.1437 1.77322 10.4552 2.81461 9.41383L4.22883 7.99962M11.7713 7.99962L13.1855 6.5854C14.2269 5.544 14.2269 3.85556 13.1855 2.81417C12.1441 1.77277 10.4557 1.77277 9.41428 2.81417L8.00006 4.22838"
        stroke="#B5B8BF" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_13516_444550">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default LinkBrokenIcon;
